import axios from 'axios'
import { apiUrl } from 'Services/accessUrl'

const endpoint = `${apiUrl.stable}/suporte`

/**
 * @property {ApiSupportTicket} ticket
 * @returns {Promise. <{ data: { identifier: string }}>}
 */
export const sendTicket = (ticket) => {
  const url = `${endpoint}/chamado/adiciona`

  return axios.post(url, ticket)
}

export const getSupportTypes = () => {
  const url = `${endpoint}/chamado/classificacao/lista`

  return axios.get(url)
}

export default {
  sendTicket,
  getSupportTypes,
}